// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const PlccICPickupModal = css`
  div.TCPModal__InnerContent {
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    max-width: 810px;
    min-height: 392px;
    max-height: 82vh;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXL_1};
    overflow: auto;
    background-color: #fff;
    .shipping-save-btn {
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .hidden-field {
      display: none;
    }
    .btn-border {
      border-radius: 6px;
    }
    .pickup-accordion.collapsed,
    .pickup-accordion.expand {
      padding-bottom: 0px;
      padding-top: 0px;
    }
    .spc-form-heading {
      display: flex;
      align-items: center;
    }
    .pickup-modal-title {
      margin-bottom: 31px;
      line-height: 1;
      color: ${(props) => props.theme.colorPalette.gray[900]};
      text-align: left;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding: 12px 0 0;
        background-color: #f3f3f3;
      }
    }
    .alignRight {
      top: 15px;
      right: 20px;
    }
    .TextBox__input {
      padding: 16px 15px;
    }
    .CheckBox__input:checked:after {
      left: 7px;
      top: 3px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      top: initial;
      max-height: 90vh;
      height: initial;
      min-height: 352px;
      left: initial;
      transform: inherit;
      bottom: 0;
      padding: 0 0 27px 0;
      .shipping-address-details {
        padding: 34px 29px 0;
      }
      .pickup-accordion.collapsed,
      .pickup-accordion.expand {
        min-height: 392px;
        max-height: 82vh;
        overflow: auto;
      }

      .shipping-save-btn {
        width: 76%;
        margin: 0 12%;
      }
      .reg-shipping-header-container {
        margin: 26px 0 10px 0;
      }
      .reg-shipping-header {
        margin: 0;
      }
      .reg-shipping-parent-cta {
        top: initial;
        position: initial;
      }
      .alignRight {
        top: 12px;
        position: absolute;
        z-index: 1002;
      }
      .pickup-modal-title {
        width: 100%;
        margin: 0;
        height: 46px;
        text-align: center;
        line-height: 46px;
        padding: 0;
        margin-bottom: 0;
        position: fixed;
        z-index: 1001;
        border-radius: 10px 10px 0 0;
      }
      .spc-card-content {
        padding: 10px;
        margin-top: 45px;
      }
    }
  }
`;

export default PlccICPickupModal;
